export default "__VITE_ASSET__B03NT5s5__"